var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 51,
    viewBox: "0 0 46 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 48H7C5.59987 48 4.8998 48 4.36503 47.7275C3.89463 47.4878 3.51218 47.1055 3.27248 46.635C3 46.1003 3 45.4003 3 44V39.7102C3 38.1212 3 37.3265 3.11995 36.664C3.67717 33.586 6.08605 31.1773 9.16395 30.62C9.35625 30.5853 9.55925 30.5605 9.78938 30.543C10.352 30.5 10.6333 30.4785 11.009 30.5065C11.3996 30.5358 11.618 30.5743 11.9949 30.6805C12.3575 30.7828 13.0107 31.0787 14.317 31.6705C15.4738 32.1945 16.709 32.576 18 32.7925M42.6815 33.5095C42.511 33.5198 42.3393 33.525 42.1668 33.525C39.6055 33.525 37.2693 32.381 35.5 30.5C33.7307 32.381 31.3945 33.5247 28.8332 33.5247C28.6607 33.5247 28.489 33.5195 28.3185 33.5093C28.1105 34.4633 28 35.4638 28 36.4948C28 42.0303 31.187 46.6813 35.5 48C39.813 46.6813 43 42.0303 43 36.4948C43 35.4638 42.8895 34.4633 42.6815 33.5095ZM30.5 13C30.5 18.5229 26.0227 23 20.5 23C14.9771 23 10.5 18.5229 10.5 13C10.5 7.47715 14.9771 3 20.5 3C26.0227 3 30.5 7.47715 30.5 13Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPp);
export default __webpack_public_path__ + "static/media/pp.6ee36daff32cc0cea578b63e813384c9.svg";
export { ForwardRef as ReactComponent };